import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import device from 'managers/device';
import { ActivityFormEditorConfig } from 'managers/topic/form';
import './stage.html';
import './stage.scss';

export interface ThreadEditingOverlayStageConfig {
    editorConfig: SubscribableOrNullableValue<ActivityFormEditorConfig>
}

@injectable()
export default class ThreadEditingOverlayStage {
    toolsContainer = ko.observable<HTMLElement>();

    editorConfig: Subscribable<ActivityFormEditorConfig | undefined>

    isReady: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) config: ThreadEditingOverlayStageConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        this.editorConfig = ko.flattenComputed(config.editorConfig).pluck(config => (<ActivityFormEditorConfig>{
            ...config,

            toolsContainer: ko.pureComputed(() => device.isDesktop() ? this.toolsContainer() : undefined)
        }));

        this.isReady = this.editorConfig.isNotNull();

        ko.applyBindingsToNode(info.element, {
            'css': {
                'thread-editing-overlay-stage': true
            }
        });
    }
}